import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, Dictionary, HttpApiRepository } from '@softline/core';
import { Task } from '../types/task';
import { SOFTLINE_API_TASK_BY_ID, SOFTLINE_API_TASKS_BY_WORKFLOW } from '../workflow.api';

@Injectable()
export class TaskRepository extends HttpApiRepository<Task, any, any, { id: number }> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_TASK_BY_ID);
  }
  override getLoadPathParams(params: any): Dictionary<unknown> {
    return { id: params.id };
  }

  protected override getCRUDPathParams(params: any): Dictionary<unknown> {
    return { id: params.id };
  }

  getTaskByWorkflowId(workflowId: string): Promise<Task> {
    return this.dataAccess.get<Task>({
      path: SOFTLINE_API_TASKS_BY_WORKFLOW,
      pathParams: { workflowId },
    });
  }
}
